var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("HeadInfo"),
      _vm._v(" "),
      _c("Nav"),
      _vm._v(" "),
      _vm.type === "plot" ? _c("Diversityplot") : _vm._e(),
      _vm._v(" "),
      _vm.type === "still" ? _c("Stills") : _vm._e(),
      _vm._v(" "),
      _vm.type === "cast" ? _c("Casts") : _vm._e(),
      _vm._v(" "),
      _c("like"),
      _vm._v(" "),
      _c("Gotop"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }